import { INIT_FAILED as t } from "@liff/consts";
import { createLiffError as n, compareVersion as e } from "@liff/util";
import { getOS as o } from "@liff/get-os";
import { getLineVersion as r } from "@liff/get-line-version";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function i(t, n, e, o) {
  return new (e || (e = Promise))(function (r, i) {
    function l(t) {
      try {
        c(o.next(t));
      } catch (n) {
        i(n);
      }
    }

    function s(t) {
      try {
        c(o.throw(t));
      } catch (n) {
        i(n);
      }
    }

    function c(t) {
      var n;
      t.done ? r(t.value) : (n = t.value, n instanceof e ? n : new e(function (t) {
        t(n);
      })).then(l, s);
    }

    c((o = o.apply(t, n || [])).next());
  });
}

function l(t, n) {
  var e,
      o,
      r,
      i,
      l = {
    label: 0,
    sent: function sent() {
      if (1 & r[0]) throw r[1];
      return r[1];
    },
    trys: [],
    ops: []
  };
  return i = {
    next: s(0),
    throw: s(1),
    return: s(2)
  }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
    return this;
  }), i;

  function s(i) {
    return function (s) {
      return function (i) {
        if (e) throw new TypeError("Generator is already executing.");

        for (; l;) {
          try {
            if (e = 1, o && (r = 2 & i[0] ? o.return : i[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, i[1])).done) return r;

            switch (o = 0, r && (i = [2 & i[0], r.value]), i[0]) {
              case 0:
              case 1:
                r = i;
                break;

              case 4:
                return l.label++, {
                  value: i[1],
                  done: !1
                };

              case 5:
                l.label++, o = i[1], i = [0];
                continue;

              case 7:
                i = l.ops.pop(), l.trys.pop();
                continue;

              default:
                if (!(r = l.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                  l = 0;
                  continue;
                }

                if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                  l.label = i[1];
                  break;
                }

                if (6 === i[0] && l.label < r[1]) {
                  l.label = r[1], r = i;
                  break;
                }

                if (r && l.label < r[2]) {
                  l.label = r[2], l.ops.push(i);
                  break;
                }

                r[2] && l.ops.pop(), l.trys.pop();
                continue;
            }

            i = n.call(t, l);
          } catch (s) {
            i = [6, s], o = 0;
          } finally {
            e = r = 0;
          }
        }

        if (5 & i[0]) throw i[1];
        return {
          value: i[0] ? i[1] : void 0,
          done: !0
        };
      }([i, s]);
    };
  }
}

function s() {
  var t;
  return "ios" === o() ? (t = r()) && e(t, "9.19.0") < 0 ? "https://static.line-scdn.net/liff/edge/2/ios-918-extensions.js" : "https://static.line-scdn.net/liff/edge/2/ios-extensions.js" : "https://static.line-scdn.net/liff/edge/2/non-ios-extensions.js";
}

function c() {
  return function () {
    return i(this, void 0, void 0, function () {
      return l(this, function (e) {
        switch (e.label) {
          case 0:
            return [3, 2];

          case 1:
            return [2, e.sent().default];

          case 2:
            return [2, new Promise(function (e, o) {
              var r = document.createElement("script"),
                  i = s();
              r.onload = function () {
                var r = window.liffClientExtension;
                r ? e(r) : o(n(t, "Unable to load client features. (Extension is empty)"));
              }, r.onerror = function () {
                o(n(t, "Unable to load client features."));
              }, r.src = i, r.type = "text/javascript", document.body.appendChild(r);
            })];
        }
      });
    });
  }();
}

export { c as load };